'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ListIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ListIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="List-Bullets-1--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>List Bullets 1 Streamline Icon: https://streamlinehq.com</desc>
        <defs></defs>
        <title>list-bullets-1</title>
        <path
          d="m8.5 4.498 15 0"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m8.5 12.498 15 0"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m8.5 20.498 15 0"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M1.5 2.498h2s1 0 1 1v2s0 1 -1 1h-2s-1 0 -1 -1v-2s0 -1 1 -1"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M1.5 10.498h2s1 0 1 1v2s0 1 -1 1h-2s-1 0 -1 -1v-2s0 -1 1 -1"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M1.5 18.498h2s1 0 1 1v2s0 1 -1 1h-2s-1 0 -1 -1v-2s0 -1 1 -1"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

ListIcon.propTypes = {
  sx: PropTypes.object
}
